module.exports = __webpack_public_path__ + "static/12gde-2ec97aec3074c32dc1f8de3da6e8d5e9.gif";